export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14454.de820766.jpg";